import { FC } from 'react'
import { useIntl } from 'react-intl'
import { useQueryClient } from 'react-query'

import QueueNumbersAPI from '@api/queueNumbersAPI'

import { ID } from '@models/base'

import { Tooltip } from '@components/Tooltip'

import { QUERIES } from '@/constants/queries'
import { useAlert } from '@/hooks'
import AxiosUtil from '@/utils/axiosUtil'

type Props = {
  queueId: ID
  queueNumberId: ID
  number: string
}

const QueueNodeRedeployButton: FC<Props> = ({ queueId, queueNumberId, number }) => {
  const intl = useIntl()
  const alert = useAlert()
  const client = useQueryClient()

  const openSuccessModal = () => {
    alert.success({
      text: intl.formatMessage({ id: 'queue.redeploy.text' }, { number: number }),
    })
  }

  const openErrorModal = (error: string) => {
    alert.error({
      text: error,
    })
  }

  const openRedeployModal = () => {
    alert
      .question({
        text: intl.formatMessage({ id: 'queue.redeploy.modal' }, { number: number }),
        confirmButtonText: intl.formatMessage({
          id: 'queue.redeploy.modal_confirm',
        }),
      })
      .then(async ({ isConfirmed }) => {
        if (isConfirmed) {
          redeployNode()
        }
      })
  }

  const redeployNode = async () => {
    try {
      await QueueNumbersAPI.moveQueueNode({
        source_queue_id: queueId,
        queue_number_id: queueNumberId,
      })
      client.invalidateQueries(QUERIES.QUEUE_PROCESS)
      openSuccessModal()
    } catch (err) {
      if (AxiosUtil.isAxiosError(err) && err.response?.data.message) {
        openErrorModal(err.response.data.message)
      }
      console.error(err)
    }
  }

  return (
    <Tooltip
      placement="top"
      text={intl.formatMessage({ id: 'queue.redeploy.button_text' })}
    >
      <button
        type="button"
        className="btn btn-sm btn-icon btn-secondary"
        onClick={openRedeployModal}
      >
        <i className="fas fa-diagram-predecessor"></i>
      </button>
    </Tooltip>
  )
}
export { QueueNodeRedeployButton }
